import React, { useContext } from "react";
import ThemeContext from "../../contexts/ThemeContext";

/**
 * Loader de tela usado como fallback do Suspense enquanto o chunk da rota é
 * baixado. Visual corporativo: spinner circular na cor primária do projeto.
 * var(--primary) acompanha o tema (claro #e45412 / escuro #ff6a21).
 */
const BRAND = "var(--primary, #e45412)";

export default function RouteLoader({ label = "Carregando", inline = false }) {
  const isDark = useContext(ThemeContext)?.theme === "dark";
  // `inline`: ocupa só a área da página (o menu lateral continua visível, e o
  // contorno do item ativo pode deslizar enquanto a tela carrega). Sem ele, cobre
  // a tela inteira (carga inicial do app).
  const containerStyle = inline
    ? {
        position: "relative",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: "route-loader-fade 0.25s ease-out",
      }
    : {
        position: "fixed",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: isDark ? "#1b1823" : "#ffffff",
        zIndex: 50,
        animation: "route-loader-fade 0.25s ease-out",
      };
  return (
    <div role="status" aria-live="polite" style={containerStyle}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 22,
        }}
      >
        <div
          style={{
            position: "relative",
            width: 56,
            height: 56,
          }}
        >
          {/* halo de pulso sutil atrás do spinner */}
          <span
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              background: BRAND,
              opacity: 0.12,
              animation: "route-loader-pulse 1.6s ease-in-out infinite",
            }}
          />
          {/* spinner */}
          <svg
            width="56"
            height="56"
            viewBox="0 0 50 50"
            style={{ animation: "route-loader-spin 0.9s linear infinite" }}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke={isDark ? "#38344a" : "#eef0f2"}
              strokeWidth="4"
            />
            <circle
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke={BRAND}
              strokeWidth="4"
              strokeLinecap="round"
              strokeDasharray="80 200"
            />
          </svg>
        </div>

        <span
          style={{
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: 1.2,
            textTransform: "uppercase",
            color: isDark ? "#9892AB" : "#9aa1ab",
          }}
        >
          {label}
          <span style={{ animation: "route-loader-dots 1.4s steps(4) infinite" }}>
            …
          </span>
        </span>
      </div>

      <style>{`
        @keyframes route-loader-spin { to { transform: rotate(360deg); } }
        @keyframes route-loader-pulse {
          0%, 100% { transform: scale(0.85); opacity: 0.10; }
          50%      { transform: scale(1.15); opacity: 0.18; }
        }
        @keyframes route-loader-dots {
          0%   { opacity: 0.25; }
          50%  { opacity: 1; }
          100% { opacity: 0.25; }
        }
        @keyframes route-loader-fade {
          from { opacity: 0; }
          to   { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
